const BASE_ROUTE = "/health-insurance";
export const QUICK_QUOTE_ROUTE = `${BASE_ROUTE}/`;
export const CREATE_QUOTE_PAGE_ROUTE = `${BASE_ROUTE}/proposal`;
export const PAYMENT_OPTIONS_PAGE_ROUTE = `${BASE_ROUTE}/product-stastus`;
export const CIS_FORM_CONFIRMATION_PAGE_ROUTE = `${BASE_ROUTE}/otp`; // why otp ??
